// extracted by mini-css-extract-plugin
export default {"outerDiv":"LoggedOutFormBackgroundLayout_outerDiv__JqUle","backgroundGradient":"LoggedOutFormBackgroundLayout_backgroundGradient__8W3Jg"};